import { jsPDF } from "jspdf";

interface GeneratePDFOptions {
  text: string;          // Text content
  fileName?: string;     // Output file name
  pageWidth?: number;    // Page width (optional)
  pageHeight?: number;   // Page height (optional)
  margin?: number;       // Margin from edges
  fontSize?: number;     // Font size
}

export const generatePDF = ({
  text,
  fileName = "document.pdf",
  pageWidth = 210,   // A4 default in mm
  pageHeight = 297,
  margin = 15,
  fontSize = 12
}: GeneratePDFOptions) => {
  const doc = new jsPDF({
    unit: "mm",
    format: [pageWidth, pageHeight]
  });

  doc.setFontSize(fontSize);

  const usableWidth = pageWidth - margin * 2;
  const lineHeight = fontSize * 0.7;

  const lines = doc.splitTextToSize(text, usableWidth);

  let cursorY = margin;

  lines.forEach((line) => {
    // If we reach the bottom margin, add a new page
    if (cursorY + lineHeight > pageHeight - margin) {
      doc.addPage();
      cursorY = margin;
    }

    doc.text(line, margin, cursorY);
    cursorY += lineHeight;
  });

  doc.save(fileName);
};